import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = ["title", "aria-label"]

import { ref } from 'vue';
import { pushToast } from '@/lib/toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'CopyButton',
  props: {
  value: String,
  title: String,
  ariaLabel: String,
  mode: {
    type: String,
    default: 'icon',
    validate: (value) => ['wrap-content', 'icon'].includes(value),
  },
  // for wrap-content mode
  iconPosition: {
    type: String,
    default: 'right',
    validate: (value) => ['left', 'right'].includes(value),
  },
},
  setup(__props) {

const props = __props;

const copied = ref(false);
const isHovered = ref(false);
async function copy() {
  const text = props.value ?? '';

  try {
    // preferred API for clipboard
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      // fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    copied.value = true;
    pushToast('Copied to clipboard!', 'success', 1000);
    window.setTimeout(() => {
      copied.value = false;
    }, 1200);
  } catch (e) {
    console.error('Copy failed', e);
  }
}

const title = props.title ?? 'Copy';
const ariaLabel = props.ariaLabel ?? 'Copy to clipboard';

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (__props.mode === 'wrap-content')
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "tw-relative tw-inline-flex tw-items-center tw-justify-center focus:tw-bg-indigo-500/20 focus:tw-border-rounded",
        style: {"border-bottom":"1px dotted #ccc"},
        title: copied.value ? 'Copied' : _unref(title),
        "aria-label": _unref(ariaLabel),
        onClick: _withModifiers(copy, ["prevent","stop"]),
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = false))
      }, [
        _renderSlot(_ctx.$slots, "default"),
        (isHovered.value)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "copy",
              class: _normalizeClass(["tw-h-3.5 tw-w-3.5 tw-absolute tw-z-100 tw-text-slate-400", __props.iconPosition === 'left' ? '-tw-left-4' : '-tw-right-4'])
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ], 40, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2 tw-py-1 tw-text-slate-600 hover:tw-bg-slate-200 hover:tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500/20",
        title: copied.value ? 'Copied' : _unref(title),
        "aria-label": _unref(ariaLabel),
        onClick: copy
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "copy",
          class: "tw-h-3.5 tw-w-3.5"
        })
      ], 8, _hoisted_2))
}
}

})